import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/$version/default-content/$page")({
    beforeLoad: ({ params }) => {
        const pageNumber = Number(params.page);
        const page = Number.isInteger(pageNumber) && pageNumber > 1 ? pageNumber : undefined;
        throw redirect({
            to: "/$version/default-content",
            params: { version: params.version },
            search: (prev) => ({ ...prev, page }),
            replace: true,
        });
    },
});
